const FirebaseConfigType = Object.freeze({
  DEV: {
    KS: {
      apiKey: 'AIzaSyAJt_9bjaiSEeSkyk6eqFh9ccRlN54tmT4',
      authDomain: 'patos-dev.firebaseapp.com',
      databaseURL: 'https://patos-dev.firebaseio.com',
      projectId: 'patos-dev',
      storageBucket: 'patos-dev.appspot.com',
      messagingSenderId: '827057510490',
      appId: '1:827057510490:web:6bf887bfcd168c5588a063',
      measurementId: 'G-BPST8C4MBK',
    },
  },
  PROD: {
    KS: {
      apiKey: 'AIzaSyCJlJIhwQT1JG3195YtOo_pjGYuPq0vJ9A',
      authDomain: 'patos-prod.firebaseapp.com',
      databaseURL: 'https://patos-prod-default-rtdb.europe-west1.firebasedatabase.app',
      projectId: 'patos-prod',
      storageBucket: 'patos-prod.appspot.com',
      messagingSenderId: '752438780288',
      appId: '1:752438780288:web:521ff68d0f1213ed56e165',
      measurementId: 'G-QLS0NKL727',
    },
    BH: {
      apiKey: 'AIzaSyDPRtLxkNrS_O0-dCNtuBjF5E8svX7HOX0',
      authDomain: 'patos-bh.firebaseapp.com',
      databaseURL: 'https://patos-bh-default-rtdb.firebaseio.com/',
      projectId: 'patos-bh',
      storageBucket: 'patos-bh.appspot.com',
      messagingSenderId: '754641010570',
      appId: '1:754641010570:web:f4d7e33163566b81e25273',
      measurementId: 'G-7JP62Z3524',
    },
  },
});

export default FirebaseConfigType;
